import store from "../../../../store";

export function transparentColor() {
  let style = "";
  const preferences = store.state.room.sessionPreferences;
  if (preferences && preferences.transparentColor) {
    style = `background-color: ${preferences.transparentColor} !important;`;
  }
  return style;
}

export function backgroundColor() {
  let style = "";
  const preferences = store.state.room.sessionPreferences;
  if (preferences && preferences.backgroundColor) {
    style = `background-color: ${preferences.backgroundColor} !important;`;
  }
  return style;
}
